const capitalize = (word) => {
    return word ? word[0].toUpperCase() + word.slice(1) : ''
}

// Convert "hello_there" -> "Hello There"
const pascalToTitle = (word) => word.split('_').map(capitalize).join(' ')

export { capitalize, pascalToTitle }
